import isEmail from 'validator/lib/isEmail'

import { isTrulyEmpty } from './empty'

/**
 * Addresses that are syntactically valid but that we refuse to store, because they are
 * well-known placeholders rather than real inboxes.
 */
const EMAIL_BLOCKLIST = [
  'change@me.com',
]

/**
 * Canonical client-side email check. Kept in sync with `apps/api/src/utils/emails.ts`.
 *
 * Duplicated rather than shared because the API cannot import from `libs/*` and the
 * `@mmx/shared` barrel pulls in Angular. Both copies delegate to the same
 * `validator/lib/isEmail`, so client and server agree on what a valid address is.
 *
 * TODO: extract into a root-level, framework-agnostic util library that every app in the
 * monorepo (including the API) can consume, and delete both copies.
 */
export function isValidEmail(email?: string | null): email is string {
  return !isTrulyEmpty(email) &&
    typeof email === 'string' &&
    isEmail(email) &&
    !EMAIL_BLOCKLIST.includes(email.toLowerCase())
}
